module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAABLklEQVQoU4WRT0/CQBDF35QWWGsT4Btxlq9AesAj1GAgSMh2+eOZE57wu3ECRCIxJGxDt2nN1OgBQ3zHnTezvzdDrdb9Z61WKyZJAmMM0jQDEZBlgGVZcN0bABk2m7eYer1+HASB43m3yNhxoUKhgPV6g/l8bqjbfdRhKEWlUvlj/HnYbrcIQxVRu93R0+lEVKvVq2aeLKWMKAge9GQyFofDB4gsCCHAX3OG4/EIz/NydilVxMy63++JxeIFq9UqL7DRcWwYk6Ber6PRuMNs9hxRpxPkGGma4nw+51OJKA/LTa7r4nQ6QakxM7N5/A/zGlKGEQ0GQz0aDQWzXdNut4NSis1Pse/7zvfq+CD028MoHHq/f8dy+Wqo2fQ/y+VSkQt8vUvZto1SqQitdfwFACCSlrCKvjwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/persondata/personal_icon_zhankai.png
// module id = 64zp
// module chunks = 1